export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "Das Lernziel wurde mir deutlich.",
			},
			{
				id: 2,
				text: "Die angestrebten Lernziele wurden von vorneherein gut definiert.",
			},
			{
				id: 3,
				text: "Die Veranstaltung war übersichtlich und verständlich.",
			},
			{
				id: 4,
				text: "Der inhaltliche Aufbau der Veranstaltung war logisch/nachvollziehbar.",
			},
			{
				id: 5,
				text: "Ich habe mich schon vor der Veranstaltung für das Thema interessiert.",
			},
			{
				id: 6,
				text: "Das Thema der Veranstaltung ist als solches relevant.",
			},
			{
				id: 7,
				text: "Ich habe das Gefühl in der Veranstaltung Wichtiges gelernt zu haben.",
			},
			{
				id: 8,
				text: "Das behandelte Thema enthält Bezüge zu meiner späteren Berufstätigkeit.",
			},
			{
				id: 9,
				text: "Die Schwere des Stoffes war angemessen.",
			},
			{
				id: 10,
				text: "Der Umfang des Stoffes war angemessen.",
			},
			{
				id: 11,
				text: "Das Tempo der Veranstaltung war angemessen.",
			},
			{
				id: 12,
				text: "Die Anforderungen der Veranstaltung waren angemessen.",
			},
			{
				id: 13,
				text: "Der Zeitaufwand für die Veranstaltung insgesamt (inkl. Vor- und Nachbereitung) war angemessen.",
			},
			{
				id: 14,
				text: "Insgesamt hat mich die Veranstaltung überfordert.",
			},
			{
				id: 15,
				text: "Ich habe mich durch die Veranstaltung unterfordert gefühlt.",
			},
			{
				id: 16,
				text: "Die Qualität des Online-Materials war gut.",
			},
			{
				id: 17,
				text: "Es wurde genügend Online-Material zur Vertiefung des Stoffes angeboten.",
			},
			{
				id: 18,
				text: "Das Online-Material war rechtzeitig zugänglich.",
			},
			{
				id: 19,
				text: "Das Online-Material trug zum Verständnis der Inhalte bei.",
			},
			{
				id: 20,
				text: "Es gab durch die Online-Tools ausreichend viel Möglichkeit zur Interaktion mit dem / der Dozenten/in.",
			},
			{
				id: 21,
				text: "Es gab durch die Online-Tools ausreichend viel Möglichkeit zur Interaktion mit anderen Studierenden.",
			},
			{
				id: 22,
				text: "Die Online-Termine waren gut organisiert und leicht erreichbar.",
			},
			{
				id: 23,
				text: "Die Möglichkeiten digitaler Lehre über traditionelle Lehre hinaus (Diskussionsforen, interaktive Aufgaben etc.) wurden gut genutzt.",
			},
			{
				id: 24,
				text: "Insgesamt waren die digitalen Elemente der Veranstaltung gut.",
			},
			{
				id: 25,
				text: "Die Veranstaltung ist ein Beispiel für gute digitale Lehre.",
			},
			{
				id: 26,
				text: "Die verfügbaren Materialien waren optimal dazu geeignet, die Veranstaltung nachzuarbeiten.",
			},
			{
				id: 27,
				text: "Die Übung war für mich hilfreich.",
			},
			{
				id: 28,
				text: "Die Übung hat mein Verständnis der Inhalte vertieft.",
			},
			{
				id: 29,
				text: "Zur kritischen Auseinandersetzung mit den behandelten Themen wurde ich durch die Übung angeregt.",
			},
			{
				id: 30,
				text: "Der Stoff wurde innerhalb der Übung anhand von Beispielen veranschaulicht.",
			},
			{
				id: 31,
				text: "Die Bedeutung der behandelten Themen wurde innerhalb der Übung vermittelt.",
			},
			{
				id: 32,
				text: "Ein Bezug zwischen Theorie und Praxis/Anwendung wurde innerhalb der Übung hergestellt.",
			},
			{
				id: 33,
				text: "Insgesamt fand ich die Veranstaltung gut.",
			},
			{
				id: 34,
				text: "In der Veranstaltung habe ich viel gelernt.",
			},
			{
				id: 35,
				text: "Meine Erwartungen an die Veranstaltung wurden erfüllt.",
			},
			{
				id: 36,
				text: "Ich würde die Veranstaltung weiterempfehlen.",
			},
		],
	},
	{
		type: "special",
		id: 2,
		items: [
			{
				id: 37,
				text: "Besuchen Sie die entsprechende Präsenzvorlesung?",
				label: [
					{
						id: 1,
						text: "Ja, regelmäßig",
					},
					{
						id: 2,
						text: "Ja, ab und zu",
					},
					{
						id: 3,
						text: "Sehr selten",
					},
					{
						id: 4,
						text: "Nein, gar nicht",
					},
				],
			},
		],
	},
	{
		type: "text",
		id: 3,
		items: [
			{
				id: 38,
				text: "Zu welchem Zweck nutzen Sie das Online-Material?",
			},
			{
				id: 39,
				text: "Sonstige Anmerkungen zu der Veranstaltung (Lob/Kritik/Vorschlag)",
			},
		],
	},
	{
		type: "age",
		id: 4,
		items: [
			{
				id: 40,
				text: "Alter: ",
			},
		],
	},
	{
		type: "dsp",
		id: 5,
		items: [
			{
				id: 41,
				text: "Der Dozent/Die Dozentin war engagiert und motiviert.",
			},
			{
				id: 42,
				text: "Der Dozent/Die Dozentin ermöglichte eine gute Lern- und Arbeitsatmosphäre.",
			},
			{
				id: 43,
				text: "Der Dozent/Die Dozentin war stets gut vorbereitet.",
			},
			{
				id: 44,
				text: "Der Dozent/Die Dozentin konnte Kompliziertes verständlich machen.",
			},
			{
				id: 45,
				text: "Insgesamt bewerte ich die Leistung des Dozenten / der Dozentin mit der Note",
				values: ["sehr gut", "gut", "befriedigend", "ausreichend", "ungenügend"],
			},
		],
	},
];
